import { JobQueuePage } from '@client/components/_business/jobs/JobQueuePage';
import type { JobData } from '@client/components/_business/jobs/JobTable';
import { useNavigate } from '@client/hooks/navigation/useNavigate';
import { createFileRoute } from '@tanstack/react-router';
import { Alert, Tag } from 'antd';

export const Route = createFileRoute('/admin-console/advanced/jobs/dynamic-recurring')({
    staticData: {
        breadcrumb: { title: 'Dynamic recurring jobs' },
        ui: {
            title: 'Dynamic recurring jobs',
            subtitle: 'Organisation-specific scheduled jobs with custom intervals and configurations',
            widthVariant: 'default',
            menuDescription: 'Organisation-specific schedules',
        },
    },
    component: DynamicRecurringJobs,
});

function DynamicRecurringJobs() {
    const navigate = useNavigate();

    const handleJobClick = (job: JobData) => {
        if (job?.id) {
            navigate({
                to: '/admin-console/advanced/jobs/dynamic-recurring/$jobId',
                params: { jobId: job.id.toString() },
            });
        }
    };

    return (
        <JobQueuePage
            route={Route}
            jobType="dynamic-recurring"
            documentTitle="Dynamic recurring jobs"
            searchPlaceholder="Search by ID, name, org, status, or error..."
            onJobClick={handleJobClick}
            introAlert={
                <Alert
                    type="info"
                    showIcon
                    title="Dynamic recurring jobs"
                    description="These are organisation-specific scheduled jobs that run on custom intervals. Each organisation can have different schedules and configurations for the same job type."
                    closable
                />
            }
            statisticsAdornment={
                <Tag variant="outlined" color="purple" className="ml-4">
                    Organisation-specific
                </Tag>
            }
        />
    );
}
